/* eslint-disable jsx-a11y/label-has-associated-control */
import "./styles.scss"

import React from "react"
import { Link, withPrefix } from "gatsby"
import LazyLoad from "react-lazyload"

import { useComparedProducts } from "context/compared_products"
import { useFavoriteProducts } from "context/favorite_products"
import AddToCart from "components/AddToCart/AddToCart"
import LazyPlaceholder from "components/LazyPlaceholder/LazyPlaceholder"

import IcoShield from "assets/images/ico-shield.svg"

const ProductTileWide = ({
  id,
  databaseId,
  slug,
  className,
  title,
  price,
  regularPrice,
  promoPrice,
  lastItems,
  favouriteType,
  stockQuantity,
  image,
  cartConfirmation,
  setCartConfirmation,
  addToCartHidden,
  tags,
  paKlasaProduktus,
  productCategories,
  product_data,
  guarantee,
}) => {
  const { local_storage_favorites_products, setProductToFavorites } =
    useFavoriteProducts()
  const { local_storage_compared_products, setProductToCompare } =
    useComparedProducts()

  const isOnSale = price !== regularPrice

  return (
    <>
      <div
        className={`product-tile product-tile--wide ${
          className ? className : ""
        }`}
      >
        <div className="product-tile__wide-image">
          <LazyLoad height={231} placeholder={<LazyPlaceholder />}>
            <Link to={`/${slug}`} className="product-tile__image">
              {image ? (
                <img src={image?.sourceUrl} alt={title} />
              ) : (
                <img
                  className="product-tile__image--placeholder"
                  src={withPrefix("/ico-product-laptop-placeholder.svg")}
                  alt={title}
                />
              )}
            </Link>
          </LazyLoad>
        </div>

        <div className="product-tile__inner">
          <div className="product-tile__wide-top">
            <div className="product-tile__cta-labels">
              {tags?.map((item, index) => (
                <label className="product-tile__promo-label" key={index}>
                  {item?.name}
                </label>
              ))}
              {isOnSale && (
                <label className="product-tile__promo-label  product-tile__promo-label--last">
                  Promocja
                </label>
              )}
            </div>

            <div className="product-tile__cta product-tile__wide-cta">
              {favouriteType ? (
                <button
                  className="product-tile__remove"
                  onClick={e => {
                    e.preventDefault()
                    setProductToFavorites(id)
                  }}
                >
                  Remove
                </button>
              ) : (
                <div className="product-tile__cta-actions">
                  <button
                    className={
                      local_storage_compared_products.indexOf(id) > -1
                        ? "is-compared"
                        : ""
                    }
                    onClick={() => setProductToCompare(id)}
                  >
                    <img
                      src={
                        require("assets/images/ico-product-tile-clipboard.svg")
                          .default
                      }
                      alt=""
                    />
                  </button>
                  <button
                    className={
                      local_storage_favorites_products.indexOf(id) > -1
                        ? "is-favourite"
                        : ""
                    }
                    onClick={e => {
                      e.preventDefault()
                      setProductToFavorites(id)
                    }}
                  >
                    <img
                      src={
                        require("assets/images/ico-product-tile-heart.svg")
                          .default
                      }
                      alt=""
                    />
                  </button>
                </div>
              )}
            </div>
          </div>

          <Link to={`/${slug}`}>
            <p className="product-tile__title">{title}</p>
          </Link>
          <div className="product-tile__info">
            {paKlasaProduktus?.nodes?.map((item, index) => (
              <div key={index}>
                Klasa <span>{item.name}</span>
              </div>
            ))}
            {!productCategories?.nodes?.some(
              category =>
                category.name === "Akcesoria" || category.name === "Torby"
            ) && (
              <div>
                <img src={IcoShield} alt="" />
                {guarantee || "Gwarancja 12 mies."}
              </div>
            )}
          </div>
          <div className="product-tile__bottom">
            <div className="product-tile__price-block">
              <div className="product-tile__price-block-row">
                {isOnSale && (
                  <h4 className="product-tile__promo-price">{price}</h4>
                )}
                <h4
                  className={`product-tile__price${
                    isOnSale ? " product-tile__price--with-promo" : ""
                  }`}
                >
                  {isOnSale ? regularPrice : price}
                </h4>
              </div>
              {isOnSale && product_data?.lowestPrice ? (
                <div className="product-tile__omnibus">
                  Najniższa cena z ostatnich 30 dni: {product_data?.lowestPrice}
                </div>
              ) : null}
            </div>
          </div>
          <div>
            <div className="product-tile__cart-button">
              {!addToCartHidden && stockQuantity > 0 && (
                <AddToCart
                  type="archive"
                  databaseId={databaseId}
                  cartConfirmation={cartConfirmation}
                  setCartConfirmation={setCartConfirmation}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProductTileWide
